<template>
  <div class="home">
    <!-- <div id="fb-root"></div> -->
    <header id="top-head" class="header">
      <h1 href="#app"><a class="header__logo" href="#app">第八期 文字塾展 「ちりもつもればかなとなる」 Online</a></h1>
      <nav id="global-nav" class="global__nav">
        <a href="#about" class="gnav__item gnav__01">展示概要</a>
        <a href="#works" class="gnav__item gnav__02">作品展示</a>
        <a href="#pamphlet" class="gnav__item gnav__03">冊子配布</a>
        <a href="#onlinelive" class="gnav__item gnav__04">ライブ配信</a>
        <!-- <a href="https://youtu.be/kbLzqaElnnU" target="_blank" v-if="sessionalStatus === 'mid'" class="gnav__item gnav__youtube">文字塾YouTubeチャンネル</a> -->
      </nav>

      <div class="navbar-end">
        <b-dropdown aria-role="list" :mobile-modal="false" position="is-bottom-left">
          <button class="button is-primary" slot="trigger" slot-scope="{ active }">
            <span class="header__dropdownbtn__icon" :class="active ? 'menu-up' : 'menu-down'">▼</span>
          </button>

          <b-dropdown-item aria-role="listitem" href="#about" class="gnav__item gnav__01">展示概要</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" href="#works" class="gnav__item gnav__02">作品展示</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" href="#pamphlet" class="gnav__item gnav__03">冊子配布</b-dropdown-item>
          <b-dropdown-item aria-role="listitem" href="#onlinelive" class="gnav__item gnav__04">ライブ配信</b-dropdown-item>

        </b-dropdown>
      </div>

    </header>

    <div class="mainContent">
      <section class="topimg">
        <div class="topinfo-wrap">
          <!-- <a class="topinfo-item" href="https://youtu.be/kbLzqaElnnU" target="_blank" v-if="sessionalStatus === 'mid'">
            <h3 class="topinfo-header">作品公開中</h3>
            <img class="topinfo-image" src="../assets/img/topimg/topinfo-01.png" srcset="../assets/img/topimg/topinfo-01.png 1x, ../assets/img/topimg/topinfo-01@2x.png 2x, ../assets/img/topimg/topinfo-01@3x.png 3x" alt="">
            <div class="topinfo-body">
              <h2 class="topinfo-title">第八期文字塾展YouTube</h2>
              <p class="topinfo-description">書体作品の説明を塾生が行います。塾長からのごあいさつと、作品への講評を交えた対談もご覧ください。</p>
            </div>
          </a>
          <a class="topinfo-item" href="https://youtu.be/4XufyzoFEc8" target="_blank" v-if="sessionalStatus === 'mid'">
            <h3 class="topinfo-header">7.19 14:00生放送</h3>
            <img class="topinfo-image" src="../assets/img/topimg/topinfo-02.png" srcset="../assets/img/topimg/topinfo-02.png 1x, ../assets/img/topimg/topinfo-02@2x.png 2x, ../assets/img/topimg/topinfo-02@3x.png 3x" alt="">
            <div class="topinfo-body">
              <h2 class="topinfo-title">YouTubeライブイベント</h2>
              <p class="topinfo-description">今田欣一さんをお招きして書体作品を通した文字塾とのクロストークイベントをライブ配信します。</p>
            </div>
          </a> -->
        </div>
        <div class="topimg_bgimg topimg_bgimg-1"></div>
        <div class="topimg_bgimg topimg_bgimg-2"></div>
        <div class="topimg_bgimg topimg_bgimg-3"></div>
        <div class="topimg_bgimg topimg_bgimg-4"></div>
        <div class="topimg_bgimg topimg_bgimg-5"></div>
      </section>

      <section class="about">
        <h2 class="title h2">展示概要<a id="about" class="hash_anchor"></a></h2>
        <p class="message">たくさんのご来場<br class="is-hidden-tablet">誠にありがとうございました。<br>
          2020年の文字塾展はWebページと<br class="is-hidden-tablet">YouTube上で開催しました。<br>
          作品の展示期間は、例年同様に会期限定の展示で会期は終了いたしました。
        </p>
        <h2 class="title h3">会期</h2>
        <p class="date"><span v-text="$store.getters['getStartDate'].format('YYYY')"></span>年<span v-text="$store.getters['getStartDate'].format('M')"></span>月<span v-text="$store.getters['getStartDate'].format('D')"></span>日（{{$store.getters['getStartDate'].format('ddd')}}）<span v-text="$store.getters['getStartDate'].format('HH:mm')"></span><span> – </span><br class="is-hidden-tablet"><span v-text="$store.getters['getEndDate'].format('D')"></span>日（{{$store.getters['getEndDate'].format('ddd')}}）<span v-text="$store.getters['getEndDate'].format('HH:mm')"></span></p>

        <div class="columns about__description">
          <div class="column">
            <h3 class="h3">文字塾展ご挨拶</h3>
            <p class="is-serif">文字塾は、阿佐ケ谷美術専門学校の協力を得て、一年をかけて塾生が自身の仮名を作り、フォント化してその成果を発表するという塾です。今回は第八期目となります。例年、文字塾展と称し人形町ヴィジョンズで開催しておりましたが、今年はCOVID-19の影響を受け、やむなくWeb上での文字塾展となりました。展示方法の違いはあるものの、場所を問わず、多くの皆さまに観ていただけることが大きなメリットと感じております。</p>
            <p class="is-serif">塾生は、学生、美大助手、グラフィックデザイナー、フォントデザイナー、エディトリアルデザイナー、エンジニア、印刷会社に勤務する人、さらに台湾のデザイナーで構成されています。彼らは授業の合間に、また仕事の合間を縫うように文字と対峙してきました。その成果が今回掲載した12作品です。血と汗にまみれた塾生の一年の成果の一端をご覧いただければ幸いです。</p>
            <p class="is-serif">また最終日（7/19）には欣喜堂の今田欣一さんをお招きして、塾生との対話をライブ配信する予定です。今田さんは私の写研時代の同僚で、文字の歴史、中でも印刷された文字の歴史についてはもっとも詳しいデザイナーのひとりではないかと思います。そしてその歴史上の文字から着想を得た書体も数多く制作しています。「きざはし金陵」はその代表作です。その今田さんが塾生の作品をどう見るのか、はたまた塾長の文字に向かう姿勢をどう見るのか、すこし怖いですが楽しみでもあります。</p>
            <p class="is-serif">最後に、コンテンツの制作においては、塾生たちが忙しい中、時間を割いて対応してくれました。お疲れさまでした。</p>
            <p class="has-text-right is-serif">文字塾塾長　鳥海修</p>
          </div>
          <div class="column student">
            <h3 class="h3">参加者</h3>
            <div class="text pc-only">
              <div class="namejob">
                <div class="name">阿部央輔</div>
                <div class="centerLine"><hr></div>
                <div class="job">会社員</div>
              </div>

              <div class="namejob">
                <div class="name">今市達也</div>
                <div class="centerLine"><hr></div>
                <div class="job">グラフィックデザイナー</div>
              </div>

              <div class="namejob">
                <div class="name">岩崎奈々美</div>
                <div class="centerLine"><hr></div>
                <div class="job">タイプデザイナー</div>
              </div>

              <div class="namejob">
                <div class="name">城井文平</div>
                <div class="centerLine"><hr></div>
                <div class="job">グラフィックデザイナー</div>
              </div>

              <div class="namejob">
                <div class="name">久藤和彦</div>
                <div class="centerLine"><hr></div>
                <div class="job">ディレクター</div>
              </div>

              <div class="namejob">
                <div class="name">黒岩美桜</div>
                <div class="centerLine"><hr></div>
                <div class="job">グラフィックデザイナー</div>
              </div>

              <div class="namejob">
                <div class="name">清水悠登</div>
                <div class="centerLine"><hr></div>
                <div class="job">プログラマ</div>
              </div>

              <div class="namejob">
                <div class="name">張軒豪<span class="is-hidden-mobile">（ジョー・チャン）</span></div>
                <div class="centerLine"><hr></div>
                <div class="job">グラフィックデザイナー</div>
              </div>

              <div class="namejob">
                <div class="name">角田彰利</div>
                <div class="centerLine"><hr></div>
                <div class="job">大学職員</div>
              </div>

              <div class="namejob">
                <div class="name">土肥優利香</div>
                <div class="centerLine"><hr></div>
                <div class="job">グラフィックデザイナー</div>
              </div>

              <div class="namejob">
                <div class="name">日比野純子</div>
                <div class="centerLine"><hr></div>
                <div class="job">クリエイター</div>
              </div>

              <div class="namejob">
                <div class="name">彭慧然<span class="is-hidden-mobile">（クリオ・ペン）</span></div>
                <div class="centerLine"><hr></div>
                <div class="job">グラフィックデザイナー</div>
                <p class="is-size-7">※五十音順、計12名、2020年7月現在</p>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section class="works">
        <h2 class="h1">作品展示<a id="works" class="hash_anchor"></a></h2>
        <p class="date" v-if="sessionalStatus === 'pre'" v-html="startDateCountDownStr"></p>
        <p class="caption is-serif has-text-centered" v-if="sessionalStatus === 'pre'">作品の展示は<span v-text="$store.getters['getStartDate'].format('M月D日HH:mm')"></span>から<span v-text="$store.getters['getEndDate'].format('M月D日')"></span>の期間のみ公開されます。<br>展示公開日までお待ちください。</p>
        <p class="caption is-serif" v-if="sessionalStatus === 'post'">作品の展示は<span v-text="$store.getters['getEndDate'].format('M月D日')"></span>をもちまして終了いたしました。たくさんのご来場・視聴をいただきましてありがとうございました。</p>
        <p class="caption is-serif" v-if="sessionalStatus === 'mid'">作品の展示は<span v-text="$store.getters['getStartDate'].format('M月D日HH:mm')"></span>から<span v-text="$store.getters['getEndDate'].format('M月D日')"></span>の期間のみ公開されます。作品は作品閲覧からご覧ください。作品の解説は動画解説をご覧ください。</p>
        <!-- <img src="../assets/img/2020-05-06_23h06_38.png" alt="" class="works__thumbnail"> -->
        <!-- <div class="button__wrapper" v-if="sessionalStatus === 'mid'">
          <button class="button" @click="showWorksModal">作品閲覧</button>
          <a href="https://youtu.be/kbLzqaElnnU" target="_blank" class="button">動画解説</a>
        </div> -->
      </section>

      <section class="eyecatch">
        <img src="../assets/img/photo_8th_4.jpg" class="scene">
      </section>

      <section class="pamphlet">
        <h2 class="h2">冊子配布<a id="pamphlet" class="hash_anchor"></a></h2>
        <p class="caption is-serif">活動の記録となる冊子を制作いたしました。制作者による書体紹介と組見本、今田欣一さんによる各書体の解説、塾長からのコメントを掲載しております。定員に達し受付を終了しました。たくさんのお申し込みありがとうございました。</p>
        <div class="pamphlet__thumbnail__wrap">
          <div class="pamphlet__thumbnail__item pamphlet__thumbnail__item--left">
            <img src="../assets/img/pamphlet/pamphlet_thumb01.png" srcset="../assets/img/pamphlet/pamphlet_thumb01.png 1x, ../assets/img/pamphlet/pamphlet_thumb01@2x.png 2x, ../assets/img/pamphlet/pamphlet_thumb01@3x.png 3x" alt="">
          </div>
          <div class="pamphlet__thumbnail__item pamphlet__thumbnail__item--right">
            <img src="../assets/img/pamphlet/pamphlet_thumb02.png" srcset="../assets/img/pamphlet/pamphlet_thumb02.png 1x, ../assets/img/pamphlet/pamphlet_thumb02@2x.png 2x, ../assets/img/pamphlet/pamphlet_thumb02@3x.png 3x" alt="">
            <img src="../assets/img/pamphlet/pamphlet_thumb03.png" srcset="../assets/img/pamphlet/pamphlet_thumb03.png 1x, ../assets/img/pamphlet/pamphlet_thumb03@2x.png 2x, ../assets/img/pamphlet/pamphlet_thumb03@3x.png 3x" alt="">
          </div>
        </div>
        <h3 class="h3">冊子申込受付期間（第二期受付）</h3>
        <p class="date date--small"><span v-text="$store.getters['getPamphletOrderStartDate'].format('YYYY')"></span>年<span v-text="$store.getters['getPamphletOrderStartDate'].format('M')"></span>月<span v-text="$store.getters['getPamphletOrderStartDate'].format('D')"></span>日（{{$store.getters['getPamphletOrderStartDate'].format('ddd')}}）<span v-text="$store.getters['getPamphletOrderStartDate'].format('HH:mm')"></span><span> – </span><br class="is-hidden-tablet"><span v-text="$store.getters['getPamphletOrderEndDate'].format('M')"></span>月<span v-text="$store.getters['getPamphletOrderEndDate'].format('D')"></span>日（{{$store.getters['getPamphletOrderEndDate'].format('ddd')}}）<span v-text="$store.getters['getPamphletOrderEndDate'].format('HH:mm')"></span></p>
        <!-- <p class="note">先着200名、1名1冊まで・フォーム送信後に送料として300円を指定口座までお振込いただきます。<br>期日前でも申込数が在庫に達し次第申込フォームの受付を終了します。</p> -->
        <!-- <div class="button__wrapper" v-if="pamphletOrderlStatus === 'mid'">
          <a class="button button--narrowpadding" href="https://docs.google.com/forms/d/e/1FAIpQLSdj7FkRRdB1O0EfaaYdjuM1ZxOn8mn2jNO64mxqZoOJtN4oSQ/viewform" target="_blank">冊子申込フォーム</a>
        </div> -->
      </section>

      <section class="onlinelive">
        <h2 class="title h2">ライブ配信<a id="onlinelive" class="hash_anchor"></a></h2>
        <h3 class="h1" v-if="sessionalStatus === 'pre'"><span class="is-hidden-mobile">『</span>今田欣一<br class="is-hidden-tablet">×<br class="is-hidden-tablet">文字塾<span class="is-hidden-mobile">』</span></h3>
        <!-- <h3 class="h1" v-if="sessionalStatus === 'mid'"><a href="https://youtu.be/4XufyzoFEc8" target="_blank"><span class="is-hidden-mobile">『</span>今田欣一<br class="is-hidden-tablet">×<br class="is-hidden-tablet">文字塾<span class="is-hidden-mobile">』</span></a></h3> -->
        <h3 class="h1" v-if="sessionalStatus === 'post'"><span class="is-hidden-mobile">『</span>今田欣一<br class="is-hidden-tablet">×<br class="is-hidden-tablet">文字塾<span class="is-hidden-mobile">』</span></h3>
        <p class="caption is-serif">八期生の作品への解説を寄せてくださった今田欣一さんをゲストにお迎えし、ライブ配信イベント『今田欣一×文字塾』を開催いたします。<br>今田さんと文字塾生による対話形式で、塾生一人ひとりの制作した書体についてお話しする予定です。後半には視聴者の皆さまからコメントをいただきながら、ライブ配信ならではのフリートークを繰り広げられたらと考えております。<br>1回限りの配信となりますので、ぜひリアルタイムでお楽しみください。YouTubeで無料でご視聴いただけます。</p>
        <!-- <div class="button__wrapper" v-if="sessionalStatus === 'mid'">
          <a class="button button--narrowpadding" href="https://youtu.be/4XufyzoFEc8" target="_blank">ライブ配信</a>
        </div> -->
      <h3 class="h3">配信日時</h3>
        <p class="date"><span v-text="$store.getters['getTalkEventStartDate'].format('YYYY')"></span>年<span v-text="$store.getters['getTalkEventStartDate'].format('M')"></span>月<span v-text="$store.getters['getTalkEventStartDate'].format('D')"></span>日（{{$store.getters['getTalkEventStartDate'].format('ddd')}}）<br class="is-hidden-tablet"><span v-text="$store.getters['getTalkEventStartDate'].format('HH:mm')"></span><span> – </span><span v-text="$store.getters['getTalkEventEndDate'].format('HH:mm')"></span></p>

        <div class="columns timetable">
          <div class="column student">
            <h3 class="h3">タイムテーブル</h3>
            <div class="text pc-only">
              <div class="namejob">
                <div class="name">14:00</div>
                <div class="centerLine"><hr></div>
                <div class="job">塾長より<span class="is-hidden-mobile">イベント</span>開会のごあいさつ</div>
                </div>

                <div class="namejob">
                <div class="name">14:10</div>
                <div class="centerLine"><hr></div>
                <div class="job">書体説明と今田さんとの対話<span class="is-hidden-mobile">（前編）</span></div>
                </div>

                <div class="namejob">
                <div class="name">15:00</div>
                <div class="centerLine"><hr></div>
                <div class="job">（10分間の休憩）</div>
                </div>

                <div class="namejob">
                <div class="name">15:10</div>
                <div class="centerLine"><hr></div>
                <div class="job">書体説明と今田さんとの対話<span class="is-hidden-mobile">（後編）</span></div>
                </div>

                <div class="namejob">
                <div class="name">16:00</div>
                <div class="centerLine"><hr></div>
                <div class="job">（10分間の休憩）</div>
                </div>

                <div class="namejob">
                <div class="name">16:10</div>
                <div class="centerLine"><hr></div>
                <div class="job">質疑応答</div>
                </div>

                <div class="namejob">
                <div class="name">16:30</div>
                <div class="centerLine"><hr></div>
                <div class="job">フリートーク</div>
                </div>

                <div class="namejob">
                <div class="name">16:50</div>
                <div class="centerLine"><hr></div>
                <div class="job">塾長より<span class="is-hidden-mobile">イベント</span>閉会のごあいさつ</div>
                <p class="is-size-7">（<span class="is-hidden-mobile">イベントの</span>内容は予告なく変更になる場合がございます）</p>
              </div>

            </div>
          </div>
        </div>

        <div class="columns is-desktop profile__title">
          <div class="column">
            <h3 class="h3">鳥海修<span class="is-small">（とりのうみおさむ）</span></h3>
            <p class="is-serif">1955年山形県生まれ。多摩美術大学卒業。<a href="http://www.jiyu-kobo.co.jp/" target="_blank">有限会社字游工房</a>の書体設計士。ヒラギノシリーズ、こぶりなゴシック、游明朝体、游ゴシック体など、ベーシック書体を中心に100書体以上の書体開発に携わる。2002年第一回佐藤敬之輔顕彰、2005年グッドデザイン賞、2008年東京TDCタイプデザイン賞を受賞。京都精華大学客員教授、武蔵野美術大学非常勤講師。著書に『<a href="https://www.shobunsha.co.jp/?p=4004" target="_blank">文字を作る仕事</a>』（晶文社）、『<a href="http://www.kawade.co.jp/np/isbn/9784309256276/" target="_blank">本をつくる 書体設計、活版印刷、手製本ー職人が手でつくる谷川俊太郎詩集</a>』（河出書房新社、共著）がある。</p>
          </div>
          <div class="column">
            <h3 class="h3">今田欣一<span class="is-small">（いまだきんいち）</span></h3>
            <p class="is-serif">活字書体設計師。1954年岡山県生まれ。1977年九州産業大学芸術学部デザイン学科卒業。1997年<a href="http://www.kinkido.net/INFOMATION/information.html" target="_blank">有限会社今田欣一デザイン室</a>を創業し、自社ブランド「<a href="http://www.kinkido.net/" target="_blank">欣喜堂</a>」でデジタルタイプの制作・販売を展開。「日本語書体八策」、「和字書体三十六景・十二勝」、「ほしくずやコレクション」など数多くのデジタルタイプ開発に携わっている。2017年に第16回佐藤敬之輔賞（個人部門）を受賞。主著に『<a href="http://www.kinkido.net/Specimen/Books_BR.html" target="_blank">活字書体の履歴書［青春朱夏編］</a>』（欣喜堂、2017年）など。活字と書物の勉強会「<a href="http://www.kinkido.net/typeKIDS/typeKIDS.html" target="_blank">typeKIDS</a>」を主宰。</p>
          </div>
        </div>
      </section>

      <footer>Copyright © Mojijuku All rights reserved.<br>当サイトに掲載されている文章及び画像の無断利用を禁じます。</footer>
    </div>
    <b-modal :active.sync="isWorksModalActive" :width="683" scroll="keep" class="works__modal">
      <div class="works__thumb__header">閲覧する作品を選択してください</div>
      <div class="works__thumb__wrap">
        <div class="works__thumb__item">
          <router-link to="/imaichitatsuya"><img src="../assets/img/works/imaichitatsuya@2x.png" srcset="../assets/img/works/imaichitatsuya@2x.png 1x, ../assets/img/works/imaichitatsuya@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/kuroiwamio"><img src="../assets/img/works/kuroiwamio@2x.png" srcset="../assets/img/works/kuroiwamio@2x.png 1x, ../assets/img/works/kuroiwamio@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/dohiyurika"><img src="../assets/img/works/dohiyurika@2x.png" srcset="../assets/img/works/dohiyurika@2x.png 1x, ../assets/img/works/dohiyurika@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/iwasakinanami"><img src="../assets/img/works/iwasakinanami@2x.png" srcset="../assets/img/works/iwasakinanami@2x.png 1x, ../assets/img/works/iwasakinanami@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/shimizuyuto"><img src="../assets/img/works/shimizuyuto@2x.png" srcset="../assets/img/works/shimizuyuto@2x.png 1x, ../assets/img/works/shimizuyuto@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/abehirosuke"><img src="../assets/img/works/abehirosuke@2x.png" srcset="../assets/img/works/abehirosuke@2x.png 1x, ../assets/img/works/abehirosuke@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/kiibunpei"><img src="../assets/img/works/kiibunpei@2x.png" srcset="../assets/img/works/kiibunpei@2x.png 1x, ../assets/img/works/kiibunpei@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/kudoukazuhiko"><img src="../assets/img/works/kudoukazuhiko@2x.png" srcset="../assets/img/works/kudoukazuhiko@2x.png 1x, ../assets/img/works/kudoukazuhiko@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/kliopeng"><img src="../assets/img/works/kliopeng@2x.png" srcset="../assets/img/works/kliopeng@2x.png 1x, ../assets/img/works/kliopeng@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/joechang"><img src="../assets/img/works/joechang@2x.png" srcset="../assets/img/works/joechang@2x.png 1x, ../assets/img/works/joechang@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/hibinojunko"><img src="../assets/img/works/hibinojunko@2x.png" srcset="../assets/img/works/hibinojunko@2x.png 1x, ../assets/img/works/hibinojunko@3x.png 3x" alt=""></router-link>
        </div>
        <div class="works__thumb__item">
          <router-link to="/tsunodaakitoshi"><img src="../assets/img/works/tsunodaakitoshi@2x.png" srcset="../assets/img/works/tsunodaakitoshi@2x.png 1x, ../assets/img/works/tsunodaakitoshi@3x.png 3x" alt=""></router-link>
        </div>
      </div>
      <button class="modal-close is-large" @click="hideWorksModal"></button>
    </b-modal>
  </div>
</template>

<script>

import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')
const duration = require('dayjs/plugin/duration')
dayjs.extend(duration)

setInterval(function () {//一秒間に一回再取得

}, 1000);

export default {
  name: 'Home',
  components: {
  },
  computed: {
    startCountDownChanges: {
      get : function(){
        return this.startDateCountDownStr;
      },
      set : function(v){
        this.startDateCountDownStr =  v;
      }
    },
    sessionalStatus() {
      const nowDate = dayjs()
      let   thisSessionalStatus = 'pre';
      if (nowDate.isAfter(this.$store.getters['getStartDate'])) {
        // 開始日以降
        if (nowDate.isBefore(this.$store.getters['getEndDate'])) {
          // 終了日以前
          thisSessionalStatus = 'mid';
        } else {
          // 終了日以降
          thisSessionalStatus = 'post';
        }
      } else {
        // 開始日以前
        thisSessionalStatus = 'pre';
      }
      // メンバープレビュー用
      if (this.$route.name === 'Home-mid') {
        thisSessionalStatus = 'mid';
        console.log('mid')
      } else if(this.$route.name === 'Home-post') {
        thisSessionalStatus = 'post';
        console.log('post')
      }
      this.$store.dispatch('updateSessionalStatus', thisSessionalStatus)
      return this.$store.getters['getSessionalStatus']
    },
    time() {
      return this.$store.state.eventStartDate.format('HH:mm:ss')
    },
    pamphletOrderlStatus() {
      const nowDate = dayjs()
      let   thisPamphletOrderStatus = 'pre';
      if (nowDate.isAfter(this.$store.getters['getPamphletOrderStartDate'])) {
        // 開始日以降
        if (nowDate.isBefore(this.$store.getters['getPamphletOrderEndDate'])) {
          // 終了日以前
          thisPamphletOrderStatus = 'mid';
        } else {
          // 終了日以降
          thisPamphletOrderStatus = 'post';
        }
      } else {
        // 開始日以前
        thisPamphletOrderStatus = 'pre';
      }
      // メンバープレビュー用
      if (this.$route.name === 'Home-mid') {
        thisPamphletOrderStatus = 'mid';
      } else if(this.$route.name === 'Home-post') {
        thisPamphletOrderStatus = 'post';
      }
      this.$store.dispatch('updatePamphletOrderStatus', thisPamphletOrderStatus)
      return this.$store.getters['getPamphletOrderStatus']
    },
  },
  mounted: function(){
    this.updateStartCountDownChanges();
  },
  beforeDestroy () {
    clearInterval(this.startDateCountDownInterval)
  },
  methods: {
    // 作品閲覧クリック用method
    showWorksModal () {
      this.$store.dispatch('updateIsWorksModalActive', true)
      this.isWorksModalActive = true
      this.$gtag.event('modal', { method: 'showWorksList' })
    },
    hideWorksModal () {
      this.$store.dispatch('updateIsWorksModalActive', false)
      this.isWorksModalActive = false
    },
    afterEnter () {
      this.isWorksModalActive = this.$store.getters['getIsWorksModalActive']
    },
    afterLeave () {
      // this.$root.$emit('triggerScroll')
    },
    updateStartCountDownChanges (){
      this.startDateCountDownInterval = setInterval(function(){
        // diffメソッドを使って、日時の差を、ミリ秒で取得
        const diff = this.$store.getters['getStartDate'].diff( dayjs() );

        // ミリ秒からdurationオブジェクトを生成
        const duration = dayjs.duration( diff );

        // 日・時・分・秒を取得
        const days = Math.floor( duration.asDays());
        const hours   = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        const nowDate = dayjs()
        if (days < 0 && hours < 0 && minutes < 0 && seconds < 0) {
          if (nowDate.isAfter(this.$store.getters['getStartDate'])) {
            if (nowDate.isBefore(this.$store.getters['getEndDate'])) {
              this.$store.dispatch('updateSessionalStatus', 'mid')
            } else {
              this.$store.dispatch('updateSessionalStatus', 'post')
            }
          }
        }

        //カウントダウンの結果を変数に代入
        this.startCountDownChanges = '公開まであと<br><span>' + days + '</span>日<span>' +  hours + '</span>時間<span>' + minutes + '</span>分<span>' + seconds + '</span>秒';
      }.bind(this), 1000);
    }
  },
  data() {
    return {
      isWorksModalActive: this.$store.getters['getIsWorksModalActive'],
      startDateCountDownStr: '',
      startDateCountDownInterval: undefined,
    }
  }
}
</script>
